import React from 'react';
import { TransferComparisonData } from '../../api/pension-plan-transfers';
import { ArcaPlan } from '../../constants/arcaPlans';
import ComparisonAdvice from './ComparisonAdvice';
import ComparisonTable from './ComparisonTable';
import { PlanReturnView, TransferReturns } from '../../utils/transferReturns';

interface SituationAnalysisProps {
	comparisonData: TransferComparisonData;
	resolvedPlan: ArcaPlan;
	/** Rentabilidades decididas por comparsa (`/plan-returns`), las mismas que la gráfica. */
	returns: TransferReturns & { arca: PlanReturnView };
	/** Saldo declarado (€), para coste/año y acumulado de la tabla. */
	balance: number;
	translate: (key: string) => string;
}

/**
 * Card única "Resumen de tu análisis": el consejo de asesor a modo de resumen y, debajo,
 * la tabla de comparación (plan actual vs elección) sin repetir los títulos de cada métrica.
 */
const SituationAnalysis: React.FC<SituationAnalysisProps> = ({
	comparisonData,
	resolvedPlan,
	returns,
	balance,
	translate
}) => (
	<div className="surface-card p-5 space-y-4">
		<ComparisonTable
			comparisonData={comparisonData}
			resolvedPlan={resolvedPlan}
			returns={returns}
			balance={balance}
			translate={translate}
		/>
		<ComparisonAdvice returns={returns} translate={translate} />
	</div>
);

export default SituationAnalysis;
